import React from "react";
import Routes from "./routes/routes";
import "./utils/var-styles.css";

export default function App() {
    return <Routes />;
}
